import cn from '@integrations/classnames'
import { getTransactionStatusName, TransactionStatuses } from 'mmfintech-backend-api'

/** Status column content: the status name, coloured by the `table-surface` status hooks. */
function TransactionStatusCell({ status }: { status?: string }) {
  return (
    <span
      className={cn('status', {
        'status-scheduled': status === TransactionStatuses.SCHEDULED,
        'status-pending': status === TransactionStatuses.PENDING,
        'status-failed': status === TransactionStatuses.FAILED,
        'status-processed': status === TransactionStatuses.PROCESSED
      })}
    >
      {getTransactionStatusName(status)}
    </span>
  )
}

export default TransactionStatusCell
